import { render, staticRenderFns } from "./TagsWrapper.vue?vue&type=template&id=43942372&scoped=true&"
import script from "./TagsWrapper.vue?vue&type=script&lang=js&"
export * from "./TagsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TagsWrapper.vue?vue&type=style&index=0&id=43942372&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43942372",
  null
  
)

export default component.exports